module.exports = __webpack_public_path__ + "img/experience04.801016d4.jpg";